/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/validators.ts (Ring Groups)
 🗓️ Created: 2025-01-15
 🧩 Description:
    Form validation utilities for Ring Groups module.

────────────────────────────────────────────────────────────────*/

import { FormState, MemberRow } from '../types';

/**
 * Validate Ring Group form
 */
export function validateForm(formData: FormState, members: MemberRow[], t: (key: string) => string): Record<string, string> {
  const errors: Record<string, string> = {};
  const name = formData.name.trim();

  if (name.length === 0) {
    errors.name = t('ringGroups.validation.nameRequired');
  } else if (name.length < 3) {
    errors.name = t('ringGroups.validation.nameMinLength');
  }

  const ringTimeout = Number(formData.ringTimeout);
  if (!Number.isFinite(ringTimeout) || ringTimeout < 1 || ringTimeout > 3600) {
    errors.ringTimeout = t('ringGroups.validation.ringTimeoutRange');
  }

  if (formData.fallbackModule !== 'none' && !formData.fallbackValue.trim()) {
    errors.fallbackValue = t('ringGroups.validation.fallbackRequired');
  }

  if (formData.forwardEnabled === 'number' && !formData.forwardNumber.trim()) {
    errors.forwardNumber = t('ringGroups.validation.forwardNumberRequired');
  }

  members.forEach((member, index) => {
    if (!member.extension.trim()) {
      errors[`member_${index}_extension`] = t('ringGroups.validation.memberExtensionRequired');
    }
  });

  return errors;
}

